function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    // On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];

  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Header and Search
const megaMenuLinks = document.querySelectorAll(".js-mega-menu-link");
const body = document.querySelector("body");

if (megaMenuLinks.length) {
  megaMenuLinks.forEach((link) => {
    link.addEventListener("mouseover", () => {
      body.classList.add("shadow--body");
    });

    link.addEventListener("mouseleave", () => {
      body.classList.remove("shadow--body");
    });
  });
}

//Add to bag functionality
class AddProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.addProduct.bind(this));
  }

  async addProduct() {
    this.classList.add("loading");
    this.setAttribute("disabled", "true");

    const variantId = this.getAttribute("data-id");
    const properties = {};
    const productObj = {
      id: variantId,
      quantity: 1,
      properties: properties,
    };

    const data = JSON.stringify(productObj);

    fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
    }).then(() => {
      this.classList.remove("loading");
      this.removeAttribute("disabled");

      publish(PUB_SUB_EVENTS.cartAdd);
    });
  }

  async getCart() {
    return fetch(`/cart.js`, { ...fetchConfig() })
      .then(response => response.text())
      .then(text => JSON.parse(text))
      .catch(e => console.error(e));
  }
}

customElements.define("add-product", AddProduct);

//Quantity input
class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.sync = this.dataset.sync === "true";

    this.querySelectorAll("button").forEach(button => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();

    const forms = document.querySelectorAll("[id^='product-form-']");
    const inputs = document.querySelectorAll(".quantity--product");

    if (this.sync) inputs.forEach(quantityInput => this.updateInput(quantityInput, event, forms));
    else this.updateInput(this, event);
  }

  updateInput(quantityInput, event, forms) {
    const previousValue = this.input.value;
    const input = quantityInput.querySelector("input");
    const minusButton = quantityInput.querySelector('button[name="minus"]');
    const isProduct = this.classList.contains("quantity--product");

    event.target.name === "plus" ? input.stepUp() : input.stepDown();

    if (previousValue !== input.value) {
      input.dispatchEvent(this.changeEvent);

      if (forms?.length) this.updateHiddenFormInput(forms);
    }

    if (isProduct && input.value === input.min) {
      minusButton.setAttribute("disabled", "true");
    } else {
      minusButton.removeAttribute("disabled");
    }
  }

  updateHiddenFormInput(forms) {
    forms.forEach(form => {
      const formInput = form.querySelector('input[name="quantity"]');

      formInput.value = this.input.value;
    });
  }
}

customElements.define("quantity-input", QuantityInput);

//Search Mobile
class Search extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onClick);

    document.addEventListener('toggle-search', this.onClick);
  }

  onClick() {
    const predictiveSearch = document.querySelector('predictive-search');
    const header = document.querySelector('.header');

    if (this == document) {
      predictiveSearch.classList.add('header__search--hidden');
      header.classList.remove('search-open');
    } else {
      predictiveSearch.classList.toggle('header__search--hidden');
      header.classList.toggle('search-open');

      document.body.classList.contains('shadow--body')
        ? this.applyShadow(false)
        : this.applyShadow(true);
    }
  }

  applyShadow(shadow) {
    if (shadow) {
      document.body.classList.add("shadow--body");
      document.body.style.position = "fixed";
    } else {
      document.body.classList.remove("shadow--body");
      document.body.style.position = "";
    }

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });
  }
}

customElements.define("search-trigger", Search);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.noteHead = this.querySelector(".js-note-header");
    this.noteInput = this.querySelector(".js-note-textarea");

    this.addListeners();
  }

  addListeners() {
    this.addEventListener('input', debounce(event => this.updateNote(event), ON_CHANGE_DEBOUNCE_TIMER));
    this.noteHead.addEventListener("click", () => this.focusInput());
  }

  focusInput() {
    this.noteInput.focus();
  }

  updateNote({ target }) {
    const body = JSON.stringify({ note: target.value.trim() });

    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .catch(e => console.log(e));
   }
}

if (!customElements.get('cart-note')) customElements.define('cart-note', CartNote);